import { useEffect, useState } from "react";
import Fuse from "fuse.js";
import * as Yup from "yup";
import { Formik } from "formik"
import Select from "react-select";
import { toast } from "react-toastify";
import { PropagateLoader } from "react-spinners";
import InputField from "../../atoms/InputField";
import TemplateForm from "../../atoms/TemplateForm";
import { GET_INMUEBLES } from "../../../api/apiInmuebles";
import { REGISTER_GASTO } from "../../../api/apiGastos";
import { getInmobiliaria } from "../../../utils/getInmobiliaria";
import { optionsTypesGastos } from "../../../utils/gastosTypes";
import { useSession } from "../../../context/SessionContext";

const GastosCreate = ({ refetch, onClose }) => {
    const { user } = useSession();
    const [inmuebles, setInmuebles] = useState();
    const [loading, setLoading] = useState(false);
    const [ , setArchivo] = useState({ file: null });

    const initialValues = {
        name: "",
        date: "",
        amount: "",
        subtotal: "",
        iva: "",
        forma_pago: "",
        titular: "",
        file: null,
        propertieId: null,
        userId: user.id,
        comments: "",
    };

    useEffect(() => {
        const getInmuebles = async () => {
            try {
                setLoading(true);
                const inmueblesData = await GET_INMUEBLES();
                setInmuebles(inmueblesData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        getInmuebles();
    }, []);

    const options = inmuebles?.map(im => ({
        value: im.id,
        label: `${im?.name} - ${getInmobiliaria(Number(im.real_estate))}`,
    }));

    const optionsPayForm = [
        { label:"Tarjeta", value:"Tarjeta" },
        { label:"Transferencia", value:"Transferencia" },
        { label:"Efectivo", value:"Efectivo" },
    ];

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            await REGISTER_GASTO(values);
            refetch();
            onClose();
            toast.success("Agregado exitosamente");
        } catch (error) {
            console.error(error);
            toast.error("Error al registrar gasto");
        } finally {
            setSubmitting(false);
        }
    };

    const validationSchema = Yup.object({
        name: Yup.string().required("Nombre es requerido"),
        amount: Yup.number().typeError("Monto debe ser un número").positive("Monto debe ser positivo").required("Monto es requerido"),
        subtotal: Yup.number().typeError("Monto debe ser un número").positive("Monto debe ser positivo").required("Monto es requerido"),
        iva: Yup.number().typeError("Monto debe ser un número").positive("Monto debe ser positivo").required("Monto es requerido"),
        propertieId: Yup.mixed().nullable().required("Selecciona un inmueble"),
        comments: Yup.string().optional(),
    });

    if (loading) { return ( <div className="w-full flex justify-center items-center py-10"> <PropagateLoader color="red" /> </div> ); }

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ values, isSubmitting, setFieldValue }) => (
                <TemplateForm
                    fields={
                        <>
                            <div>
                                <label htmlFor="name" className="text-rs-azul font-bold"> Gasto </label>
                                <Select
                                    name="name"
                                    options={optionsTypesGastos}
                                    className="h-fit border border-blue-600 rounded-md"
                                    classNamePrefix="select"
                                    value={optionsTypesGastos.find(option => option?.value === values.name)}
                                    onChange={selected => setFieldValue("name", selected ? selected.value : "")}
                                    placeholder="Selecciona tipo de gasto..."
                                    isClearable
                                />
                            </div>
                            <div>
                                <label htmlFor="propertieId" className="text-rs-azul font-bold"> Inmueble </label>
                                <Select
                                    name="propertieId"
                                    options={options}
                                    className="h-fit border border-blue-600 rounded-md"
                                    classNamePrefix="select"
                                    onChange={selected => {
                                        setFieldValue("propertieId", selected?.value || null);
                                    }}
                                    placeholder="Selecciona inmueble..."
                                    filterOption={createFuseFilter(options, ["label"])}
                                    isClearable
                                />
                            </div>
                            <div className="w-full flex flex-row gap-4">
                                <InputField name="subtotal" label="Subtotal" placeholder="$Subtotal" type="number"/>
                                <InputField name="iva" label="IVA" placeholder="$IVA" type="number"/>
                                <InputField name="amount" label="Total" placeholder="$Total" type="number"/>
                            </div>
                            <InputField name="date" label="Fecha" type="date"/>
                            <InputField
                                name="file"
                                label="Factura o recibo"
                                type="file"
                                onChange={(e) => {
                                    const file = e.currentTarget.files?.[0] || null;
                                    setFieldValue("file", file);
                                    setArchivo((prev) => ({ ...prev, file: file }));
                                }}
                            />
                            <div>
                                <label htmlFor="forma_pago" className="text-rs-azul font-bold"> Forma de pago </label>
                                <Select
                                    name="forma_pago"
                                    options={optionsPayForm}
                                    className="h-fit border border-blue-600 rounded-md"
                                    classNamePrefix="select"
                                    onChange={selectedForm => {
                                        setFieldValue("forma_pago", selectedForm ? selectedForm.value : "");
                                    }}
                                    value={optionsPayForm.find(option => option.value === values.forma_pago) || null}
                                    placeholder="Selecciona forma de pago..."
                                    isClearable
                                />
                            </div>
                            <InputField name="titular" label="TItular de la cuenta" placeholder="Titular de la cuenta"/>
                            <div className="col-span-2">
                                <InputField name="comments" type="textarea" label="Comentarios" placeholder="Comentarios"/>
                            </div>
                        </>
                    }
                    isSubmitting={isSubmitting}
                    textButton="Aceptar"
                />
            )}
        </Formik>
    );
};

export default GastosCreate;

const createFuseFilter = (optionsList, keys) => {
    const fuse = new Fuse(optionsList, {
        keys,
        threshold: 0.3,
        ignoreLocation: true,
        includeScore: false,
        useExtendedSearch: true,
    });

    return (candidate, input) => {
        if (!input) return true;
        const results = fuse.search(input);
        return results.some(res => res.item.value === candidate.value);
    };
};